// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TLrR9{display:flex;flex-direction:column;align-items:start}.TLrR9 .mLDvU{margin-bottom:32px}.vHRv6{margin:12px auto;display:flex;flex-direction:column;gap:8px;width:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `TLrR9`,
	"title": `mLDvU`,
	"progressBarContainer": `vHRv6`
};
export default ___CSS_LOADER_EXPORT___;
